import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
// Constants
import {
  COOKIE_TIMER,
  CookiePolicyName,
} from './utils/Constants';
import {
  FORGOT_PASS_PAGE_URL,
  HOME_PAGE_URL,
  MAINTENANCE_PAGE_URL,
  POLICIES_PAGE_URL,
  RESET_PASS_PAGE_URL,
} from './utils/Routes';
// Components
import LoadingScreen from './components/utils/LoadingScreen'
// Normal import for HomePage (no lazy loading)
import HomePage from './pages/home/HomePage';
import { VERIFY_EMAIL_PAGE_URL } from './utils/Routes';
import VerifyEmailPage from './users/verify/VerifyEmailPage';
// Lazy-loaded Pages
import ForgettenPasswordPage from './users/password/ForgettenPasswordPage';
import ResetLostPasswordPage from './users/password/ResetLostPasswordPage';
const MaintenancePage = lazy(() => import('./pages/maintenance/MaintenancePage'));
const Error404 = lazy(() => import('./pages/error/Error404'));
const TermAndPoliciesPage = lazy(() =>
  import('./pages/policies/TermAndPoliciesPage')
);

// Components
const CookieConsentModal = lazy(() =>
  import('./components/modals/CookieConsentModal')
);

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAgreedToCookies, setHasAgreedToCookies] = useState(true);

  useEffect(() => {
    const cookie = localStorage.getItem(CookiePolicyName);

    if (cookie) {
      setHasAgreedToCookies(true);
    } else {
      setHasAgreedToCookies(false);
    }
  }, []);

  useEffect(() => {
    if (hasAgreedToCookies) {
      setIsVisible(false);
    }

    const timer = setTimeout(() => {
      if (!hasAgreedToCookies) {
        setIsVisible(true);
      }
    }, COOKIE_TIMER);

    return () => clearTimeout(timer);
  }, [hasAgreedToCookies]);

  return (
    <>
      {isVisible && (
        <Suspense>
          <CookieConsentModal setHasAgreedToCookies={setHasAgreedToCookies} />
        </Suspense>
      )}

      {/* Suspense component wraps the lazy-loaded components */}
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* Main page routes */}
          <Route path={HOME_PAGE_URL} index element={<HomePage />} />

          {/* Eager loaded */}
          <Route path={POLICIES_PAGE_URL} element={<TermAndPoliciesPage />} />

          {/* User */}
          <Route path={VERIFY_EMAIL_PAGE_URL} element={<VerifyEmailPage />} />
          <Route
            path={FORGOT_PASS_PAGE_URL}
            element={<ForgettenPasswordPage />}
          />
          <Route
            path={RESET_PASS_PAGE_URL}
            element={<ResetLostPasswordPage />}
          />

          {/* Other */}
          <Route path={MAINTENANCE_PAGE_URL} element={<MaintenancePage />} />

          {/* Error routes */}
          <Route path='*' element={<Error404 />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
